import BackButton from "../components/global/BackButton";
import Form from "../components/clientscreen/Form";
import '../styles/clientscreen.css';

export default function ClientScreen() {
    return (
        <div className="page">
            <BackButton/>
            <Form/>
        </div>
    )
};